/*
 *
 * ColorsPanel actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';
import { Color } from 'lib/modelBuilder/entities/Color';
import { PaneMaterial } from 'lib/modelBuilder/constants';

export const displayColorsPanel = (value: boolean) =>
  action(ActionTypes.DISPLAY_COLORS_PANEL, { value });

export const updateColorPaneOnSelection = (
  material: PaneMaterial,
  color: Color,
  preview: boolean,
) =>
  action(ActionTypes.UPDATE_COLOR_PANE_ON_SELECTION, {
    material,
    color,
    preview,
  });

export const updateColorPaneOnSelectionFailure = (error: Error) =>
  action(ActionTypes.UPDATE_COLOR_PANE_ON_SELECTION_FAILURE, {
    error,
  });
